module.exports = (__webpack_require__(0))(40);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/UploadWidget.js from dll-reference girder_lib
// module id = 18
// module chunks = 0